<script>
import UserActionRequiredList from './UserActionRequiredList.vue'
import CancelOrderDialog from '@/components/common/CancelOrderDialog.vue'
export default {
  components: {
    UserActionRequiredList, CancelOrderDialog
  },
  props: {
    identifier: {
      type: String,
    },
    warnings: {
      type: Array
    },
    longTooltip: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    orderId: {
      type: Number
    }
  },
  computed: {
    headline() {
      return this.$t(this.warnings.length === 1 ?
        'component.documentValidation.userActionRequiredCard.head.action' : 'component.documentValidation.userActionRequiredCard.head.actions'
      )
    },
    buttonText() {
      return this.$t(this.warnings.length === 1 ?
        'button.execute.action' : 'button.execute.actions'
      )
    }
  }
}
</script>
<template>
  <v-card outlined elevation="0">
    <v-toolbar color="primary" dark height="48">
      <v-spacer />
      <v-toolbar-title class="text-center resetWhitespace">
        <h2 class="headline text--primary-2">{{ headline }}</h2>
      </v-toolbar-title>
      <v-spacer />
    </v-toolbar>
    <UserActionRequiredList :value="warnings" :long-tooltip="longTooltip" />
    <v-divider />
    <v-card-actions class="justify-center text-center">
      <v-btn
      :id="identifier"
      color="tertiary"
      class="normal-texttransform"
      :loading="loading"
      :disabled="disabled"
      @click="$emit('confirmWarnings')"
    >{{ buttonText }}
      </v-btn></v-card-actions>
    <v-card-actions class="justify-center text-center">
      <CancelOrderDialog
        :order-id="orderId"
        route-to="dashboard"
        class="pa-3"
      />
    </v-card-actions>
  </v-card>
</template>
